import type { LDClient } from 'launchdarkly-react-client-sdk';

import type { LDFlags } from '../shared/types';
import { camelToKebab } from '../util/utils';

let client: LDClient;

export const setClient = (newClient: LDClient) => {
  client = newClient;
};

export const getVariation = <K extends keyof LDFlags>(key: K, defaultValue: LDFlags[K]) => {
  if (!client) {
    return defaultValue;
  }

  const kebabKey = camelToKebab(key);
  return client.variation(kebabKey, defaultValue);
};
